export default [
	{
		id: 1,
		name: 'Vlatko Koudela'
	}
];
